let activeTab = "membership";
let tabs = document.querySelectorAll(".product-tab");
let tabGroups = document.querySelectorAll(".product__group");
let addOnRows = document.querySelectorAll(".addons__row");
let prizeGroups = document.querySelectorAll(".prizes__group .prize__container");
let productButtons = document.querySelectorAll(".product-button");
let productCards = document.querySelectorAll(".product-card");

let minusButton = document.querySelector('.product-input-minus-btn');
let addButton = document.querySelector('.product-input-add-btn');
let quantityInput = document.querySelector('.product-input');
let quantityText = document.querySelector('.product-entries-amount');
let entryText = document.querySelector('.product-entries-text');
let priceText = document.querySelector('.product-price');
let currentProductPrice = JSON.parse(productCards[0]?.dataset?.product);
let oneTimeExtraEntriesButton = document.getElementById('extra-entries-onetime-button');
let extraContainer = document.getElementById('extra-entries-onetime-main-container');
const isTwoForOne = window.location.pathname.includes("tickets-2for1-150k-kl") || window.location.pathname.includes ("tickets-2for1-10k-kl");
// Update old/promo entry elements
const oldEntriesEl = document.querySelector(".product-entries-amount.old-entries");
const promoEntriesEl = document.querySelector(".product-entries-amount.promo-entries");


let singleProductQuantity = isTwoForOne ? 1 : 1;
let newSingleProductQuantity = 1;



const warning = document.getElementById('quantity-warning');

function enforceMax(val) {
  if (val > 30) {
    showMaxWarning();
    return 30;
  }
  return val;
}

function showMaxWarning() {
  if (!warning) return;
  warning.style.opacity = 1;
  warning.style.display = 'block';
  quantityInput.classList.add('input-shake');


  setTimeout(() => {
    warning.style.opacity = 0;
    warning.style.display = 'none';
    quantityInput.classList.remove('input-shake');
  }, 4000);
}

const searchParams = new URLSearchParams(window.location.search);


function togglePrizeGroups(activeTab) {
  const prizeGroups = document.querySelectorAll('.prizes__group[data-type]');
  
  prizeGroups.forEach(group => {
    const groupType = group.getAttribute('data-type');

    console.info("activeTab", activeTab)
    console.info("groupType", groupType)

    if (activeTab === 'membership' && groupType === 'membership') {
      // Show membership prizes
      group.style.display = 'flex';
    } else if (activeTab === 'one-time' && groupType === 'one-time') {
      // Show one-time prizes for any non-membership tab
      group.style.display = 'flex';
    } else {
      // Show one-time prizes for any non-membership tab
      group.style.display = 'none';
    }
  });
}

createFacebookClickId = () => {
  const currentDate = Date.now();
  const fbId = `fb.1.${currentDate}.${searchParams.get("fbclid")}`;
  Cookies.set("_fbc", fbId, {
    expires: 7,
    domain: `${window.location.hostname.replace('store.', '')}`,
  });
  return fbId;
};

checkHeaderFooter = () => {
  const header = document.querySelector('.header-wrapper')
  const footer = document.querySelector('.footer')
  if(searchParams.get("webview") === "app"){
    header.style.display = "none";
    footer.style.display = "none";
  }
}


createFacebookPixel = () => {
  const currentDate = Date.now();
  const randomNumber = Math.floor(Math.random() * Date.now());
  const facebookPixelId = `fb.1.${currentDate}.${randomNumber}`;
  Cookies.set("_fbp", facebookPixelId, {
    expires: 7,
    domain: `${window.location.hostname.replace('store.', '')}`,
  });
  return facebookPixelId;
};

const facebookClickId = searchParams.has("fbclid")
  ? createFacebookClickId()
  : Cookies.get("_fbc");

const ttClickId = searchParams.get('ttclid') ?? Cookies.get('ttclid');
const ttPixelId = Cookies.get('_ttp');

let attributes = {
  ...(facebookClickId && { fb_click_id: facebookClickId }),
  fb_pixel_id: Cookies.get('_fbp') ?? createFacebookPixel(),
  custom_id: crypto.randomUUID(),
  purchase_event_id: crypto.randomUUID(),
  checkout_event_id: crypto.randomUUID(),
  cart_event_id: crypto.randomUUID(),
  origin_url: window.location.href,
  ...(ttClickId && { tiktok_click_id: ttClickId }),
  ...(ttPixelId && { tiktok_pixel_id: ttPixelId }),
  ...(searchParams.has("webview") && {webview: searchParams.get("webview")}),
  ...(searchParams.has("source") && {source: searchParams.get("source")}),
  ...(searchParams.has("referral") && {referral: searchParams.get("referral")}),
  ...(searchParams.has("challenge") && {challenge: searchParams.get("challenge")}),
  ...(searchParams.has("action") && {action: searchParams.get("action")}),
  ...(searchParams.has("product") && {product: searchParams.get("product")})
}

findCurrentVariant = (product, variantId) => {
  console.info("this is the product?", product);
  return product.variants.find((variant) => variant.id === Number(variantId));
};

proceedToCheckout = () => {
  fetch("/cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    }
  })
    .then((response) => {
      const res = response.json();
      console.info('token', res);
      if (res?.token) {
        return sessionStorage.setItem('checkoutUrl', `https://${window.location.hostname}/checkout?cart_token=${res.token}`)
      }
      return sessionStorage.setItem('checkoutUrl', `https://${window.location.hostname}/checkout`);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

checkKlaviyoState = () => {
  if(searchParams?.get("utm_source") === "Klaviyo") {
    console.log('Source: ', 'klaviyo')
    sessionStorage.setItem('isKlaviyo', 'true');
  }
  return;
}

updateCart = (e) => {
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      ...(searchParams.has("referral") && {discount: `${searchParams.get("referral")}`}),
      attributes: attributes 
    })
  })
    .then(response => {
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

addToCart = (e) => {
  console.info("addToCart", e);
  let variantId = e.target ? e.target.dataset.variant : e.dataset.variant;
  let subscriptionId = e.target ? e.target.dataset.subscription : e.dataset.subscription;
  let product = JSON.parse(e.target ? e.target.dataset.product : e.dataset.product);
  let currentVariant = findCurrentVariant(product, variantId);

  // ✅ correct quantity depending on product
  let currentQuantity = isTwoForOne ? singleProductQuantity : singleProductQuantity;

  let data = subscriptionId
    ? {
        quantity: 1,
        selling_plan: currentVariant.selling_plan_allocations[0].selling_plan_id,
        id: currentVariant.id,
      }
    : {
        quantity: currentQuantity,
        id: currentVariant?.id,
      };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => {
      console.info("response:", response);
      window.location.href =
        sessionStorage.getItem("checkoutUrl") ??
        `https://${window?.location?.hostname}/checkout`;
    })
    .catch((error) => {
      console.error("Error:", error);
    });
};

clearCart = (e) => {
  fetch(window.Shopify.routes.root + "cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      const res = response.json();
      return res;
    }).then(data => {
        console.log('Cart cleared:', data);
      })
    .catch((error) => {
      console.error("Error:", error);
    });
};

tabs.forEach((tab) => {
  tab.addEventListener("click", (currentTab) => {
    currentTab.stopPropagation();
    let activeTab = currentTab.target.getAttribute("id");
    tabs.forEach((tab) => tab.classList.remove("active-tab"));
    currentTab.target.classList.add("active-tab");
    

    tabGroups.forEach((element) => {
      if (
        element.classList.contains("active-group") &&
        element.getAttribute("id") !== activeTab
      ) {
        element.classList.remove("active-group");
      } else {
        element.classList.add("active-group");
      }
    });

    togglePrizeGroups(activeTab);


    if (activeTab !== "membership") {
      addOnRows.forEach((row) => {
        row.classList.add("no-membership");
      });
      // Always hide prizes__entries when switching to one-time tab
      // It will only be shown when the extra entries button is clicked
      const prizesEntries = document.querySelector(".prizes__entries");
      prizesEntries?.classList?.add("no-entries");
      document.querySelectorAll(".icon-unlock").forEach((element) => {
        element.classList.add("disable-unlock-icon");
      });
      document.querySelectorAll(".icon-lock").forEach((element) => {
        element.classList.add("active-lock-icon");
      });
      prizeGroups.forEach((e, index) => {
        if (index === 0) {
          e.querySelector(".prize__member-badge").classList.add(
            "remove-left-badge"
          );
        }
        // if (index !== 0) {
        //   e.classList.add("hide-group");
        // }
        // if (index == 4) {
        //   e.classList.remove("hide-group");
        // }
      });
      // Show extra entries button on one-time tab
      if(oneTimeExtraEntriesButton) {
        oneTimeExtraEntriesButton.classList.remove('hidden-element');
      }
      // Reset extra container state when switching to one-time tab
      if(extraContainer && extraContainer.classList.contains('active-group')){
        extraContainer.classList.remove('active-group');
      }
    } else {
      addOnRows.forEach((row) => {
        row.classList.remove("no-membership");
      });
      document.querySelector(".prizes__entries")?.classList?.remove("no-entries");
      document.querySelectorAll(".icon-unlock").forEach((element) => {
        element.classList.remove("disable-unlock-icon");
      });
      document.querySelectorAll(".icon-lock").forEach((element) => {
        element.classList.remove("active-lock-icon");
      });
      prizeGroups.forEach((e, index) => {
        if (index === 0) {
          e.querySelector(".prize__member-badge").classList.remove(
            "remove-left-badge"
          );
        }
        // e.classList.remove("hide-group");
      });
      // Hide extra entries button and container on membership tab
      if(oneTimeExtraEntriesButton) {
        oneTimeExtraEntriesButton.classList.add('hidden-element');
      }
      if(extraContainer) {
        extraContainer.classList.remove('active-group');
      }
    }
  });
});


// If it's the 2-for-1 page, disable manual editing and set initial state
if (isTwoForOne && quantityInput) {
  quantityInput.disabled = false;
  quantityInput.value = singleProductQuantity;

  // ✅ manual typing
  quantityInput.addEventListener("change", (val) => {
    let inputVal = parseInt(val.target.value, 10);
    if (isNaN(inputVal) || inputVal < 1) inputVal = 1;
    const oldEntriesInput = document.querySelector('.product-entries-amount-.old-entries');

    singleProductQuantity = inputVal;
    quantityInput.value = inputVal;

    if (oldEntriesInput) oldEntriesInput.innerText = singleProductQuantity;
    if (promoEntriesEl) promoEntriesEl.innerText = inputVal * 2;

    const price = (
      parseInt(currentProductPrice.price.toString().replace("00", ""), 10) *
      inputVal
    ).toFixed(2);

    entryText.innerText = inputVal * 2 === 1 ? "Entry" : "Entries";
    priceText.innerText = `$${price}`;
  });
}

// subtraction
// --- MINUS BUTTON ---
// --- MINUS BUTTON ---
if (minusButton) {
  minusButton.addEventListener("click", (value) => {
    if (isTwoForOne) {
      if (singleProductQuantity > 1) {

        const oldEntriesInput = document.querySelector('.product-entries-amount-.old-entries');

        singleProductQuantity -= 1;
        quantityInput.value = singleProductQuantity;
        if (oldEntriesInput) oldEntriesInput.innerText = singleProductQuantity;
        if (promoEntriesEl) promoEntriesEl.innerText = singleProductQuantity * 2;

        const pricing = window.location.pathname.includes("tickets-2for1-150k-kl") ? 49.00 : 20.00;

        // ✅ Each 2 entries changes price by 48.00, starting from 48.00
        const price = (singleProductQuantity * pricing).toFixed(2);

        entryText.innerText = singleProductQuantity === 1 ? "Entry" : "Entries";
        priceText.innerText = `$${price}`;
      }
      return;
    }

    // Default (non-2for1)
    if (value.target?.dataset?.multiple) {
      if (newSingleProductQuantity > 2) {
        newSingleProductQuantity -= 2;
        quantityInput.value = newSingleProductQuantity;
        quantityText.innerText = newSingleProductQuantity;

        const price = (
          parseInt(currentProductPrice.price.toString().replace("00", ""), 10) *
          newSingleProductQuantity
        ).toFixed(2);

        entryText.innerText = newSingleProductQuantity === 1 ? "Entry" : "Entries";
        priceText.innerText = `$${price}`;
      }
    } else {
      if (singleProductQuantity > 1) {
        singleProductQuantity -= 1;
        quantityInput.value = singleProductQuantity;
        quantityText.innerText = singleProductQuantity;

        const pricing = window.location.pathname.includes("tickets-150kbfcm") ? 24.50 : 49.00;

        const price = (singleProductQuantity * pricing).toFixed(2);

        // const price = (
        //   parseInt(currentProductPrice.price.toString().replace("00", ""), 10) *
        //   singleProductQuantity
        // ).toFixed(2);

        entryText.innerText = singleProductQuantity === 1 ? "Entry" : "Entries";
        priceText.innerText = `$${price}`;
      }
    }
  });
}



// --- DISABLE INPUT CHANGE EVENT FOR 2-FOR-1 ---
if (quantityInput) {
  quantityInput.addEventListener("change", (val) => {
    let inputVal = parseInt(val.target.value, 10);

    if (isNaN(inputVal) || inputVal < 1) inputVal = 1;
    if (inputVal > 30) {
      inputVal = 30;
      showMaxWarning();
    }

    singleProductQuantity = inputVal;
    quantityInput.value = inputVal;
    quantityText.innerText = inputVal;

    const pricing = window.location.pathname.includes("tickets-150kbfcm") ? 24.50 : 49.00;

    const price = (inputVal * pricing).toFixed(2);

    // let price = (
    //   parseInt(currentProductPrice.price.toString().replace("00", ""), 10) * inputVal
    // ).toFixed(2);

    entryText.innerText = inputVal === 1 ? "Entry" : "Entries";
    priceText.innerText = `$${price}`;
  });
}

// --- ADD BUTTON ---
if (addButton) {
  addButton.addEventListener("click", (value) => {
    if (isTwoForOne) {

      const oldEntriesInput = document.querySelector('.product-entries-amount-.old-entries');
      // singleProductQuantity += 1;
      singleProductQuantity = enforceMax(singleProductQuantity + 1);
      quantityInput.value = singleProductQuantity;
      // quantityInput.value = singleProductQuantity;
      if (oldEntriesInput) oldEntriesInput.innerText = singleProductQuantity;
      if (promoEntriesEl) promoEntriesEl.innerText = singleProductQuantity * 2;
      const pricing = window.location.pathname.includes("tickets-2for1-150k-kl") ? 49.00 : 20.00;

      // ✅ Each 2 entries adds 48.00
      const price = (singleProductQuantity * pricing).toFixed(2);

      entryText.innerText = singleProductQuantity === 1 ? "Entry" : "Entries";
      priceText.innerText = `$${price}`;
      return;
    }

    // Default (non-2for1)
    if (value.target?.dataset?.multiple) {
      newSingleProductQuantity += 2;
      quantityInput.value = newSingleProductQuantity;
      quantityText.innerText = newSingleProductQuantity;

      const price = (
        parseInt(currentProductPrice.price.toString().replace("00", ""), 10) *
        newSingleProductQuantity
      ).toFixed(2);

      entryText.innerText = newSingleProductQuantity === 1 ? "Entry" : "Entries";
      priceText.innerText = `$${price}`;
    } else {
      // singleProductQuantity += 1;
      // quantityInput.value = singleProductQuantity;


      singleProductQuantity = enforceMax(singleProductQuantity + 1);
      quantityInput.value = singleProductQuantity;
      
      quantityText.innerText = singleProductQuantity;
      const pricing = window.location.pathname.includes("tickets-150kbfcm") ? 24.50 : 49.00;

      const price = (singleProductQuantity * pricing).toFixed(2);
      // const price = (
      //   parseInt(currentProductPrice.price.toString().replace("00", ""), 10) *
      //   singleProductQuantity
      // ).toFixed(2);

      entryText.innerText = singleProductQuantity === 1 ? "Entry" : "Entries";
      priceText.innerText = `$${price}`;
    }
  });
}

if(oneTimeExtraEntriesButton) {
  oneTimeExtraEntriesButton.addEventListener( 'click', (value) => {
    const mainContainer = document.getElementById('extra-entries-onetime-main-container');
    if(!mainContainer) { console.info('Extra Onetime Entries container, is not available'); return; }
    const prizesEntries = document.querySelector(".prizes__entries");
    if(!mainContainer.classList.contains('active-group')) {
      mainContainer.classList.add('active-group');
      // Show prizes__entries when opening extra entries
      prizesEntries?.classList?.remove("no-entries");
    } else {
      mainContainer.classList.remove('active-group');
      // Hide prizes__entries when closing extra entries
      prizesEntries?.classList?.add("no-entries");
    }
  })
}

productButtons.forEach((e) =>
  e.addEventListener("click", (product) => {
    product.preventDefault();
    product.stopPropagation();
    console.info('product: ', product)
    addToCart(product);
  })
);

productCards.forEach((e) =>
  e.addEventListener("click", (product) => {
    product.preventDefault();
    console.info('product: ', product)
    addToCart(product);
  })
);

document.addEventListener("readystatechange", (event) => {
  updateCart();
  checkKlaviyoState();
    // clearCart();
  proceedToCheckout();
  checkHeaderFooter();
  togglePrizeGroups('one-time');
});
